import * as S from './style';

const executiveGroups = ['이사회', '감사'];
const committees = ['운영위원회', '편집위원회', '산학협력위원회', '학술위원회'];
const divisions = ['소재 분과', '제형 분과', '피부 & 천연물 효능 기전 분과', '평가 및 임상분과', '안전성 분과', '대체법 분과', 'AI분과', '제도분과'];

const Organization = () => (
	<S.OrganizationContainer>
		<S.OrganizationHeader>
			<S.Badge>Organization Chart</S.Badge>
			<S.Title>대한화장품학회 조직도</S.Title>
			<S.Description>학회의 운영 체계와 각 위원회, 분과 구성을 한눈에 볼 수 있도록 정리했습니다.</S.Description>
		</S.OrganizationHeader>

		<S.ChartCard>
			<S.TopNode>
				<S.NodeEyebrow>President</S.NodeEyebrow>
				<S.NodeTitle>(사)대한화장품학회 회장</S.NodeTitle>
			</S.TopNode>

			<S.VerticalConnector />

			<S.ExecutiveRow>
				{executiveGroups.map((item) => (
					<S.SmallNode key={item}>{item}</S.SmallNode>
				))}
			</S.ExecutiveRow>

			<S.VerticalConnector />

			<S.MidNode>평의원회</S.MidNode>

			<S.VerticalConnector />

			<S.CommitteeSection>
				<S.CommitteeColumn>
					<S.CommitteeRow>
						{committees.map((item, index) => (
							<S.CommitteeNode key={item} isAccent={index === committees.length - 1}>
								{item}
							</S.CommitteeNode>
						))}
					</S.CommitteeRow>

					<S.VerticalConnector />

					<S.OfficeNode>
						<S.NodeTitle>사무국</S.NodeTitle>
						<S.OfficeDescription>학회 모든 운영, 회계, 학술활동 등</S.OfficeDescription>
					</S.OfficeNode>
				</S.CommitteeColumn>

				<S.DivisionColumn>
					<S.DivisionHeader>
						<S.DivisionBadge>Academic Divisions</S.DivisionBadge>
						<S.DivisionTitle>학술위원회 산하 분과</S.DivisionTitle>
					</S.DivisionHeader>
					<S.DivisionList>
						{divisions.map((item) => (
							<S.DivisionNode key={item}>{item}</S.DivisionNode>
						))}
					</S.DivisionList>
				</S.DivisionColumn>
			</S.CommitteeSection>
		</S.ChartCard>
	</S.OrganizationContainer>
);

export default Organization;
